export const hasInitiatedAnalyticsSelector = state => state.analytics.initiated;
export const isAnalyticsAcceptedSelector = state => state.analytics.accepted;
